import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Home } from './Home'
import { TutorialList } from './TutorialList'
import { BannerDetails } from './BannerDetails'

export default class Tutorial extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={`${window.PATH.TUTORIAL_LIST}/:type`} component={TutorialList}/>
      <Route path={window.PATH.TUTORIAL_DETAILS} component={BannerDetails}/>
      <Route path={window.PATH.TUTORIAL} component={Home}/>
    </Switch>
  }
}
